<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4 class="text-xs-center">
        <v-progress-circular
          :size="64"
          :width="8"
          style="alignment: center;"
          v-if="show_loading"
          :indeterminate="true"
        >
        </v-progress-circular>

        <v-alert
          :value="show_alert"
          :type="alert_type"
          transition="scale-transition"
        >
          {{ alert_text }}
        </v-alert>
      </v-flex></v-layout
    ></v-container
  >
</template>

<script>
/* global firebase */
export default {
  name: "Action",
  data() {
    return {
      show_loading: false,
      show_alert: false,
      alert_type: "success",
      alert_text: "",
      mode: this.$route.query.mode,
      oobCode: this.$route.query.oobCode,
      continueUrl: this.$route.query.continueUrl,
      lang: this.$route.query.lang
    };
  },
  created() {
    switch (this.mode) {
      case "resetPassword":
        this.reset_password();
        break;
      case "recoverEmail":
        this.recover_email();
        break;
      case "verifyEmail":
        this.verify_email();
        break;
    }
  },
  methods: {
    reset_password() {},
    recover_email() {},
    verify_email() {
      this.show_alert = false;
      this.show_loading = true;

      firebase
        .auth()
        .applyActionCode(this.oobCode)
        .then(() => {
          this.show_loading = false;
        })
        .catch(() => {
          this.show_loading = false;
          this.alert_type = "error";
          this.alert_text = "Could not verify E-Mail";
          this.show_alert = true;
        });
    }
  }
};
</script>

<style scoped></style>
